module.exports = __webpack_public_path__ + "asset/image-iconCategoryUncategorized-56ff29275132b8e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryUncategorized.svg
// module id = 23tK
// module chunks = 0